import { format, parseISO } from 'date-fns';
import * as R from 'ramda';
import { formatDateForExport } from 'utils/helpers/format';

const addColsIf = (cond, columns) => {
  if (cond) return columns;

  return [];
};
const minWidth = 150;

const BillsOfLadingColumns = (isSupplier = false) => [
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    field: 'locationShortName',
    headerName: 'Location',
    minWidth,
  },
  {
    field: 'bolIdName',
    headerName: 'BOL ID',
    minWidth,
    renderCell: ({ row }) => R.propOr(null, 'bolIdName')(row), // remove commas from numbers
    type: 'number',
  },
  {
    field: 'suffix',
    headerName: 'Suffix',
    minWidth,
  },
  { field: 'line', headerName: 'Line #', minWidth, type: 'number' },
  { field: 'version', headerName: 'Version', minWidth, type: 'number' },
  {
    cellClassName: 'css-heap-redact',
    field: 'supplierIdName',
    headerName: 'Supplier ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'supplierShortName',
    headerName: 'Supplier',
    minWidth,
  },
  {
    field: 'timeofLoading',
    headerName: 'Time of Loading',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('timeofLoading', row)
        ? format(parseISO(R.prop('timeofLoading', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerIdName',
    headerName: 'Inv Owner ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerShortName',
    headerName: 'Inventory Owner',
    minWidth,
  },
  { cellClassName: 'css-heap-redact', field: 'productIdName', headerName: 'Product ID', minWidth },
  { cellClassName: 'css-heap-redact', field: 'productShortName', headerName: 'Product', minWidth },
  { field: 'customBlendIdName', headerName: 'Custom Blend ID', minWidth },
  { field: 'customBlendShortName', headerName: 'Custom Blend', minWidth },
  {
    cellClassName: 'css-heap-redact',
    field: 'netVolume',
    headerName: 'Net Volume',
    minWidth,
    type: 'number',
  },
  { field: 'netUOM', headerName: 'Net UOM', minWidth },
  {
    cellClassName: 'css-heap-redact',
    field: 'netVolumeInBarrels',
    headerName: 'Net Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'grossVolume',
    headerName: 'Gross Volume',
    minWidth,
    type: 'number',
  },
  { field: 'grossUOM', headerName: 'Gross UOM', minWidth },
  { field: 'loadMethod', headerName: 'Load Method', minWidth },
  {
    field: 'temp',
    headerName: 'Temp',
    minWidth,
    renderCell: ({ row }) => R.propOr(null, 'temp')(row), // remove commas from numbers,
    type: 'number',
  },
  {
    field: 'specificGravity',
    headerName: 'Specific Gravity',
    minWidth,
    renderCell: ({ row }) => R.propOr(null, 'specificGravity')(row), // remove commas from numbers
    type: 'number',
  },
  {
    field: 'sulfurValue',
    headerName: 'Sulfur Value',
    minWidth,
    renderCell: R.path(['row', 'sulfurValue']),
    type: 'number',
  },
  {
    field: 'businessDateBooked',
    headerName: 'Business Date Booked',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('businessDateBooked', row)
        ? format(parseISO(R.prop('businessDateBooked', row)), 'MM/dd/yyyy')
        : null,
    valueFormatter: formatDateForExport(),
  },
  ...addColsIf(isSupplier, [
    {
      cellClassName: 'css-heap-redact',
      field: 'carrierFEINIdName',
      headerName: 'Carrier FEIN',
      minWidth,
    },
    { cellClassName: 'css-heap-redact', field: 'carrierName', headerName: 'Carrier', minWidth },
    {
      cellClassName: 'css-heap-redact',
      field: 'cciCustomerIdName',
      headerName: 'CCI Customer ID',
      minWidth,
    },
    {
      cellClassName: 'css-heap-redact',
      field: 'cciCustomerShortName',
      headerName: 'CCI Customer',
      minWidth,
    },
  ]),
  { field: 'destinationIdName', headerName: 'Destination ID', minWidth },
  { field: 'destinationName', headerName: 'Destination', minWidth },
  ...addColsIf(isSupplier, [
    {
      cellClassName: 'css-heap-redact',
      field: 'loadingControlIdName',
      headerName: 'Loading Control ID',
      minWidth,
      renderCell: ({ row }) => R.propOr(null, 'loadingControlIdName')(row),
      // remove commas from numbers
      type: 'number',
    },
    { field: 'exchange', headerName: 'Exchange', minWidth },
  ]),
];

export default BillsOfLadingColumns;
